import { inject, Injectable } from '@angular/core';
import { SearchAbstractResource } from './search.abstract.resource';
import { Observable } from 'rxjs';
import { ExtensionMobilityResult } from '../../../shared/models/generated/ziroModels';
import { AuditHeaderService } from '../../../shared/services/audit-header.service';
import { Nvp } from '../../../shared/models/nvp';
import { HttpOptions } from '../../../shared/resources/abstract/model.resource.abstract';

export class SearchExtensionMobilityProfilesQueryParams {
  q?: string;
  extension?: string;
  description?: string;
  'cucm-server-id'?: number;
  limit?: number;
  name?: string;
}

@Injectable({ providedIn: 'root' })
export class SearchExtensionMobilityProfilesResource extends SearchAbstractResource {
  private auditHeaderService = inject(AuditHeaderService);

  getExtensionMobilityProfiles(
    searchParams: SearchExtensionMobilityProfilesQueryParams,
  ): Observable<ExtensionMobilityResult[]> {
    return this.search<ExtensionMobilityResult[]>(
      '/services/cisco/macs/extension-mobility-profiles/search',
      searchParams,
    );
  }

  private _buildHttpOptions(auditTags: Nvp[]): HttpOptions | object {
    return auditTags ? { headers: this.auditHeaderService.buildHeader(auditTags) } : {};
  }

  deleteExtensionMobilityProfile(
    extensionMobilityProfileId: string,
    serverId: number,
    auditTags?: Nvp[],
  ): Observable<void> {
    const httpOptions = this._buildHttpOptions(auditTags);
    return this._http.delete<void>(
      `/services/cisco/macs/cucm-servers/${serverId}/extension-mobility-profiles/${extensionMobilityProfileId}`,
      httpOptions,
    );
  }
}
